"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSignInSignUpRequest = void 0;
const utils_1 = require("../utils");
const handleSignInSignUpRequest = ({ request, userPoolClientId, oAuthConfig, customState, origin, setCookieOptions, type, }) => {
    const { codeVerifier, state } = (0, utils_1.createAuthFlowProofs)({ customState });
    const redirectUrlSearchParams = (0, utils_1.createUrlSearchParamsForSignInSignUp)({
        url: request.url,
        oAuthConfig,
        userPoolClientId,
        state,
        origin,
        codeVerifier,
    });
    const headers = new Headers();
    headers.set('Location', type === 'signIn'
        ? (0, utils_1.createAuthorizeEndpoint)(oAuthConfig.domain, redirectUrlSearchParams)
        : (0, utils_1.createSignUpEndpoint)(oAuthConfig.domain, redirectUrlSearchParams));
    (0, utils_1.appendSetCookieHeaders)(headers, (0, utils_1.createSignInFlowProofCookies)({ state, pkce: codeVerifier.value }), (0, utils_1.createAuthFlowProofCookiesSetOptions)(setCookieOptions, origin));
    return new Response(null, {
        status: 302,
        headers,
    });
};
exports.handleSignInSignUpRequest = handleSignInSignUpRequest;
